import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';
import { TranslatePipe } from '@camelot/translation';

import { CamTranslationProject } from '../../../../../translation.service';
import { ExecutionType } from '../../../services/dto/execution-type';

export const executionTypeLabel = (executionType: ExecutionType) =>
  `project.billings.execution-type.${ExecutionType[executionType]?.toLowerCase() ?? 'unknown'}`;

@Component({
  host: { 'data-cid': 'grid-billing-execution-type-cell' },
  imports: [TranslatePipe],
  selector: '',
  template: `{{ this.value ? executionTypeLabel(this.value) : ('' | translate) }}`,
})
export class GridBillingExecutionTypeCellComponent extends AbstractCellComponent<any, ExecutionType> {
  executionTypeLabel = executionTypeLabel;
  constructor() {
    super();
    CamTranslationProject.getInstance();
  }
}
